import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-header-box',
    templateUrl: './header-box.component.html',
    styleUrls: ['./header-box.component.scss'],
    standalone: false,
})
export class HeaderBoxComponent {
    @Input()
    name: string = '';
    @Input()
    showBackButton = true;

    readonly PROJECT_URL_SEGMENT: string = 'project';
    readonly IMG_DB_URL_SEGMENT: string = 'imgdb';
    readonly SUMMARY_URL_SEGMENT: string = 'summary';
    readonly WORKSPACE_URL_SEGMENT: string = 'workspace';
    readonly COMMUNITY_URL_SEGMENT: string = 'communityprojects';
    readonly SETTINGS_URL_SEGMENT: string = 'settings';
    readonly MEMBERS_URL_SEGMENT: string = 'members';

    constructor(
        private router: Router,
        private route: ActivatedRoute
    ) {}

    onGoBack() {
        const containerId = this.route.snapshot.paramMap.get('containerId');
        const url = this.route.snapshot.url.join('/');

        if (this.checkRedirectionToSplitScreen(url)) {
            this.backToSplitScreen(containerId);
        } else if (url.includes(this.SUMMARY_URL_SEGMENT)) {
            this.backToCommunityGallery();
        } else if (url.includes(this.PROJECT_URL_SEGMENT)) {
            this.backToWorkspace('projects');
        } else if (url.includes(this.IMG_DB_URL_SEGMENT)) {
            this.backToImgDb(containerId);
        } else {
            console.warn("Couldn't find route for back button, chose default.");
            this.backToWorkspace('projects');
        }
    }

    private checkRedirectionToSplitScreen(url: string): boolean {
        return !!(
            (url.includes(this.SETTINGS_URL_SEGMENT) &&
                !url.includes(this.IMG_DB_URL_SEGMENT)) ||
            (url.includes(this.MEMBERS_URL_SEGMENT) &&
                !url.includes(this.IMG_DB_URL_SEGMENT))
        );
    }

    backToSplitScreen(containerId: string): void {
        this.router.navigate([`/${this.PROJECT_URL_SEGMENT}/${containerId}`]);
    }

    backToWorkspace(workspaceSelection: string): void {
        this.router.navigate([`/${this.WORKSPACE_URL_SEGMENT}`], {
            queryParams: {
                selected: workspaceSelection,
            },
        });
    }

    backToCommunityGallery(): void {
        this.router.navigate([`/${this.COMMUNITY_URL_SEGMENT}`]);
    }

    backToImgDb(containerId: string) {
        this.router.navigate([`/${this.IMG_DB_URL_SEGMENT}/${containerId}`]);
    }
}
